import { optionNamesMatch, optionValuesMatch } from '@/utils/product/product-context-helpers';

export const BIRCH_COOLING_OPTION_NAME = 'Cooling Options';
export const BIRCH_COLOR_OPTION_NAME = 'Color';
export const BIRCH_SIZE_OPTION_NAME = 'Size';
/** Gallery tag driver priority. Add names here to support non-color variant galleries (e.g. 'Material'). */
export const BIRCH_GALLERY_OPTION_NAMES = [BIRCH_COLOR_OPTION_NAME];

export function resolveVariantSwatchesOptionName(block) {
  return (block?.section_title || block?.heading || '').trim() || BIRCH_COLOR_OPTION_NAME;
}

export function resolveVariantButtonsOptionName(block) {
  return (block?.section_title || '').trim() || BIRCH_COOLING_OPTION_NAME;
}

export function getShopifyOptionByName(shopifyProduct, optionName) {
  const opts = shopifyProduct && shopifyProduct.options;
  if (!opts) return null;
  const found = opts.find((o) => optionNamesMatch(o.name, optionName));
  return found || null;
}

export function getFirstShopifyOptionByName(shopifyProduct, optionNames) {
  if (!optionNames || !optionNames.length) return null;
  for (const optionName of optionNames) {
    const found = getShopifyOptionByName(shopifyProduct, optionName);
    if (found) return found;
  }
  return null;
}

/**
 * BL-994: `v2_extended_option_buttons` has no field naming the Shopify option it
 * drives, only rows whose `variant_name` must match an option value exactly. So
 * the option is the one whose values those rows match: `Cooling Options` on the
 * mattresses, `Height` on the Foundation, `Loft` on the Talalay pillow, `Color`
 * on the Madison frame. Ties go to Shopify's option order. With no match at all
 * it falls back to `Cooling Options`, which is what the block always assumed.
 */
export function resolveExtendedOptionsShopifyOption(shopifyProduct, variantNames) {
  const opts = shopifyProduct?.options ?? [];
  const names = (variantNames ?? []).filter(Boolean);
  let best = null;
  let bestCount = 0;

  for (const option of opts) {
    const count = names.filter((name) =>
      (option.values ?? []).some((value) => optionValuesMatch(value, name)),
    ).length;
    if (count > bestCount) {
      best = option;
      bestCount = count;
    }
  }

  return best ?? getShopifyOptionByName(shopifyProduct, BIRCH_COOLING_OPTION_NAME);
}
